<template>
  <div class="areaVue">
    <div class="content f-absolute-all f-webkit-box">
      <div class="f-w-610 f-webkit-box f-box-vertical">
        <div class="layui-panel f-p-xxs" style="flex:0.6">
          <div class="jxjb">
            <div class="titlebg">
              <div class="layui-cards-title f-lh-36 f-color-white f-p-l-xlg f-size-18">全市统计</div>
              <div class="f-p-sm row">
                <div class="f-webkit-box f-p-t-sm col-5 f-right">
                  <div class="xgbg3 f-h-full">
                    <div class="xg2"></div>
                    <div class="xg3"></div>
                    <div class="xg4"></div>
                    <div class="xg5"></div>
                    <div class="xg6"></div>
                    <i class="iconfont icon1"></i>
                  </div>
                  <div class="f-m-l-sm">
                    <div class="f-color-white f-size-14">
                      <span
                        class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                        id="lrze"
                      >{{cityStatistics.profitCount==null?'--':cityStatistics.profitCount}}</span>亿元
                    </div>
                    <div class="f-color-2f85b1 f-size-14">利润总额累计</div>
                  </div>
                </div>
                <div class="f-webkit-box f-p-t-sm col-6 f-right">
                  <div class="xgbg3 f-h-full">
                    <div class="xg2"></div>
                    <div class="xg3"></div>
                    <div class="xg4"></div>
                    <div class="xg5"></div>
                    <i class="iconfont icon2"></i>
                  </div>
                  <div class="f-m-l-sm">
                    <div class="f-color-white f-size-14">
                      <span
                        class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                        id="zyywsr"
                      >{{cityStatistics.busCount==null?'--':cityStatistics.busCount}}</span>亿元
                    </div>
                    <div class="f-color-2f85b1 f-size-14">主营业务收入累计</div>
                  </div>
                </div>
              </div>
              <div class="f-p-sm row">
                <div class="f-webkit-box f-p-b-sm col-5 f-right">
                  <div class="xgbg3 f-h-full f-info-c">
                    <div class="xg2"></div>
                    <div class="xg3"></div>
                    <div class="xg4"></div>
                    <div class="xg5"></div>
                    <i class="iconfont f-size-24 f-relative f-pt-t-xs">&#xe665;</i>
                  </div>
                  <div class="f-m-l-sm">
                    <div class="f-color-white f-size-14">
                      <span
                        class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                        id="gyyqs"
                      >{{cityStatistics.parkLibrary==null?'--':cityStatistics.parkLibrary}}</span>个
                    </div>
                    <div class="f-color-2f85b1 f-size-14">园区数</div>
                  </div>
                </div>
                <div class="f-webkit-box f-p-b-sm col-6 f-right">
                  <div class="xgbg3 f-h-full f-info-c f-p-t-xs">
                    <div class="xg2"></div>
                    <div class="xg3"></div>
                    <div class="xg4"></div>
                    <div class="xg5"></div>
                    <i class="iconfont f-size-30">&#xe6cd;</i>
                  </div>
                  <div class="f-m-l-sm">
                    <div class="f-color-white f-size-14">
                      <span
                        class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                        id="gsqy"
                      >{{cityStatistics.company==null?'--':cityStatistics.company}}</span>个
                    </div>
                    <div class="f-color-2f85b1 f-size-14">企业数</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="layui-panel f-box-flex1 f-m-t f-m-b" style="flex:0.5">
          <div class="jxjb f-h-full">
            <div class="titlebg f-h-full f-webkit-box f-box-vertical f-p-b-sm">
              <div class="layui-cards-title f-lh-36 f-color-white f-p-l-xlg f-size-18">全市工业增加值</div>
              <div class="f-p-l-sm row f-p-t-xs f-p-r-sm">
                <div class="f-webkit-box f-p-t-sm col-5 f-right">
                  <div class="xgbg3 f-h-full f-info-c">
                    <div class="xg2"></div>
                    <div class="xg3"></div>
                    <div class="xg4"></div>
                    <div class="xg5"></div>
                    <i class="iconfont f-size-36">&#xe618;</i>
                  </div>
                  <div class="f-m-l-sm">
                    <div class="f-color-white f-size-14">
                      <span
                        class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                        id="qgpm"
                      >{{cityGDP[1]==null?'--':cityGDP[1]}}</span>亿元
                    </div>
                    <div class="f-color-2f85b1 f-size-14">全市工业增加值累计</div>
                  </div>
                </div>
                <div class="f-webkit-box f-p-t-sm col-6 f-right">
                  <div class="xgbg3 f-h-full">
                    <div class="xg2"></div>
                    <div class="xg3"></div>
                    <div class="xg4"></div>
                    <div class="xg5"></div>
                    <i class="iconfont icon1"></i>
                  </div>
                  <div class="f-m-l-sm">
                    <div class="f-color-white f-size-14 upicon">
                      <span
                        class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                        id="ljtbzs"
                      >{{cityGDP[0]==null?'--':cityGDP[0]}}</span>%
                    </div>
                    <div class="f-color-2f85b1 f-size-14">累计同比增速</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="layui-panel" style="flex:0.8">
          <div class="jxjb f-h-full">
            <div class="titlebg">
              <div class="layui-cards-title f-lh-36 f-color-white f-p-l-xlg f-size-18">全市工业投资增速</div>
              <div
                class="f-p-l-sm row f-p-t-xs f-p-r-sm f-relative"
                style=" height:60px;overflow: visible;"
              >
                <div
                  class="aaaa f-webkit-box f-p-t-sm col-11 f-pt-t-sm"
                  style="position: absolute;right: -10px"
                >
                  <div class="xgbg3 f-h-full">
                    <div class="xg2"></div>
                    <div class="xg3"></div>
                    <div class="xg4"></div>
                    <div class="xg5"></div>
                    <i class="iconfont icon1"></i>
                  </div>
                  <div class="f-m-l-sm">
                    <div class="f-color-white f-size-14 upicon">
                      <span
                        class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                        id="idProgytz"
                      >{{InvestmentGrowth==null?'--':InvestmentGrowth}}</span>%
                    </div>
                    <div class="f-color-2f85b1 f-size-14">累计同比增速</div>
                  </div>
                </div>
              </div>
              <div class="f-h-260" id="main6_area"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="f-box-flex1 f-m-l">
        <div class="f-h-full pbg2">
          <div class="f-h-full layui-panel2 f-webkit-box f-box-vertical f-relative bg002">
            <div class="ctnav">
              <div class="layui-cards-title f-lh-32 f-color-white f-p-l-xlg f-size-18">全市工业经济发展情况</div>
              <div class="ctnavbox">
                <div
                  class="ctnav-item"
                  v-for="(item,index) in tabsParam"
                  @click="toggleTabs(index)"
                  :class="{active:index!=nowIndex}"
                  :key="index"
                >{{item}}</div>
              </div>
            </div>
            <div class="f-box-flex1 f-p f-relative">
              <div class="f-absolute basket" style="z-index:0;opacity: 0.6;"></div>
              <div
                id="main7_area"
                class="f-h-460 f-w-300"
                style="position: absolute;left:0;bottom:40px;z-index: 999"
              ></div>
              <div class="f-full" id="map"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div style="display:none" id="main2_ind"></div>
    <div style="display:none" id="main1_ind"></div>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "areaVue",
  props: ["searchYearMonth"],
  data() {
    return {
      tabsParam: ["增加值增速", "工业投资增速"],
      nowIndex: 0, //默认第一个tab为激活状态
      dateValue: "",
      cityStatistics: {}, //全市统计
      cityGDP: [], // 全市工业增加值
      InvestmentGrowth: 0,
      month: this.searchYearMonth,
      zoom: 1,
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
    }),
  },
  watch: {
    searchYearMonth: function (val) {
      this.month = val;
      this.dateValue = val;
      this.getData(this.month);
      this.getProgyzjzByRank(this.month);
      this.getProgyzjzByArea(this.month);
      this.getProgytzTrend(this.month);
    },
  },
  created() {
    this.getCurrentDateTime();
    this.getMapZoom();
  },
  mounted() {
    this.dateValue = this.searchYearMonth;
    this.getData(this.month);
    this.getProgyzjzByRank(this.month);
    this.getProgyzjzByArea(this.month);
    this.getProgytzTrend(this.month);
    this.getIndexYearMonth(this.month);
    this.getMapZoom();
  },
  methods: {
    getIndexYearMonth(value) {
      this.$emit("getYearMonth", value);
    },
    getMapZoom() {
      this.$axios
        .get("/business/mapSite/selectByType?type=areaMap")
        .then((res) => {
          this.zoom = res.data.data.baseNum;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getCurrentDateTime() {
      var d = new Date();
      var year = d.getFullYear();
      var month = d.getMonth() + 1;

      if (month < 10) {
        month = "0" + month;
      }
      var YM = year + "-" + month;
      this.getData(YM);
      this.getProgyzjzByRank(YM);
      this.getProgyzjzByArea(YM);
      this.getProgytzTrend(YM);
    },
    getData(month) {
      // 全市统计数据
      this.$axios
        .get("/business/monitor/area/selectCityAllByYear", {
          params: {
            dateRange: month,
          },
        })
        .then((res) => {
          this.cityStatistics = res.data.data;
        });
      // 全市工业增加值数据
      this.$axios
        .get("/business/monitor/area/selectAllCityAdd", {
          params: {
            dateRange: month,
          },
        })
        .then((res) => {
          this.cityGDP = res.data.data;
        });
      // 投资增速数据
      this.$axios
        .get("/business/monitor/area/selectAllCityInvest", {
          params: {
            dateRange: month,
          },
        })
        .then((res) => {
          this.InvestmentGrowth = res.data.data;
        });
    },

    /*'增加值增速','工业投资增速'  切换开始*/
    toggleTabs(index) {
      this.nowIndex = index;
      console.log(this.dateValue);
      if (index == 0) {
        this.getProgyzjzByRank(this.dateValue);
        this.getProgyzjzByArea(this.dateValue);
      } else {
        this.getProgyzjzByRank1(this.dateValue);
        this.getProgyzjzByArea1(this.dateValue);
      }
    },
    /*'增加值增速','工业投资增速'  切换结束*/

    /*全市工业增加值图表开始*/

    bar(id, data) {
      var chart = this.$echarts.init(document.getElementById(id));
      var datas = data.data;
      var newdata = new Object();
      newdata.series = [];
      newdata.legend = [];
      for (var i = 0; i < datas.length; i++) {
        var d = datas[i];
        var color = data.color[i];
        newdata.legend.push(d.name);
        if (d.hasOwnProperty("yIndex") && d.yIndex > 0) {
          if (d.hasOwnProperty("lineStyle")) {
            newdata.series.push({
              name: d.name,
              type: "line",
              yAxisIndex: d.yIndex,
              data: d.data,
              lineStyle: d.lineStyle,
            });
          } else {
            newdata.series.push({
              name: d.name,
              type: "line",
              yAxisIndex: d.yIndex,
              data: d.data,
            });
          }
        } else {
          newdata.series.push({
            name: d.name,
            type: "bar",
            barWidth: 10,
            yAxisIndex: 0,
            data: d.data,
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: color[0], // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: color[1], // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
              },
            },
          });
        }
      }
      var option = {
        color: ["#008efb", "#FF7F4C", "#00FFFF", "#7396FF"],
        tooltip: {
          trigger: "axis",
          confine: true,
        },
        title: {
          top: 5,
          left: "center",
          text: data.title,
          textStyle: {
            color: "#2375a1",
            fontSize: 14,
          },
        },
        legend: {
          textStyle: {
            color: "#72a8db",
          },
          itemWidth: 6,
          itemHeight: 6,
          top: 10,
          data: newdata.legend,
        },
        grid: {
          top: 40,
          left: 24,
          right: 30,
          bottom: 0,
          containLabel: true,
        },
        yAxis: [
          {
            type: "value",
            name: "亿",
            nameGap: 10,
            nameTextStyle: {
              color: "#205da3",
              padding: [0, 20, 0, 0],
            },
            splitNumber: 4,
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: "#042c44",
              },
            },
            axisLabel: {
              color: "#205da3",
            },
            axisLine: {
              lineStyle: {
                color: "#0462aa",
              },
            },
          },
          {
            type: "value",
            name: "%",
            nameGap: 10,
            offset: 5,
            nameTextStyle: {
              color: "#205da3",
              padding: [0, 0, 0, 20],
            },
            splitNumber: 4,
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              color: "#205da3",
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#0462aa",
              },
            },
          },
        ],
        xAxis: {
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          boundaryGap: true,
          axisLabel: {
            color: "#205da3",
          },
          axisLine: {
            lineStyle: {
              color: "#0462aa",
            },
          },
          data: data.dataAxis,
        },
        series: newdata.series,
      };
      chart.setOption(option);
    },
    /*全市工业增加值图表结束*/

    // 全市工业投资增速图表开始
    getProgytzTrend(month) {
      this.$axios
        .get("/business/monitor/area/selectBuSync", {
          params: {
            dateRange: month,
          },
        })
        .then((result) => {
          var dataAxisList = [];
          var dataList = [];

          for (let i = 0; i < result.data.data.length; i++) {
            dataAxisList[dataAxisList.length] = result.data.data[i].dateRange;
            dataList[dataList.length] = result.data.data[i].growth;
          }
          var data = {
            dataAxis: dataAxisList,
            data: [{ name: "", value: dataList }],
          };
          this.area("main6_area", data);
        });
    },

    area(id, data) {
      var chart = this.$echarts.init(document.getElementById(id));
      var legend = [],
        serys = [];
      for (var i = 0; i < data.data.length; i++) {
        legend.push(data.data[i].name);
        serys.push({
          name: data.data[i].name,
          type: "line",
          data: data.data[i].value,
          smooth: true,
          symbol: "circle",
          symbolSize: 2,
          areaStyle: {
            opacity: 0.3,
          },
          emphasis: {
            label: {
              show: false,
            },
          },
        });
      }
      var option = {
        color: ["#009944", "#e99b30", "#fe6327", "#007dfe", "#26c9ff"],
        tooltip: {
          trigger: "item",
          confine: true,
        },
        legend: {
          textStyle: {
            color: "#72a8db",
          },
          icon: "circle",
          itemWidth: 6,
          itemHeight: 6,
          top: 0,
          right: "center",
          data: legend,
        },
        grid: {
          top: 30,
          left: 20,
          right: 30,
          bottom: 20,
          containLabel: true,
        },
        yAxis: [
          {
            type: "value",
            nameTextStyle: {
              color: "#205da3",
              padding: [0, 20, 0, 0],
            },
            splitNumber: 4,
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: "#042c44",
              },
            },
            axisLabel: {
              formatter: "{value}%",
              color: "#2d6480",
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#0462aa",
              },
            },
          },
        ],
        xAxis: {
          boundaryGap: false,
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            color: "#2d6480",
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#0462aa",
            },
          },
          data: data.dataAxis,
        },
        series: serys,
      };
      chart.setOption(option);
    },
    // 全市工业投资增速图表结束

    // 全市工业经济发展情况 左下图表开始
    getProgyzjzByRank(month) {
      this.$axios
        .get("/business/monitor/area/selectDistrictAddGrowth", {
          params: {
            dateRange: month,
          },
        })
        .then((result) => {
          var resultData = result.data.data;
          var axisArr = [];
          var dataArr = [];
          for (var i = 0; i < resultData.length; i++) {
            axisArr.push(resultData[i].name);
            dataArr.push({
              value: resultData[i].growth,
            });
          }
          var data = {
            axis: axisArr,
            max: 20,
            data: dataArr,
          };
          data.length = 7;
          this.cardBar("main7_area", data);
        });
    },

    getProgyzjzByRank1(month) {
      this.$axios
        .get("/business/monitor/area/selectDistrictInvestGrowth", {
          params: {
            dateRange: month,
          },
        })
        .then((result) => {
          var resultData = result.data.data;
          var axisArr = [];
          var dataArr = [];
          for (var i = 0; i < resultData.length; i++) {
            axisArr.push(resultData[i].name);
            dataArr.push({
              value: resultData[i].growth,
            });
          }
          var data = {
            axis: axisArr,
            max: 20,
            data: dataArr,
          };
          data.length = 7;
          this.cardBar("main7_area", data);
        });
    },

    cardBar(id, data) {
      var chart = this.$echarts.init(document.getElementById(id));
      var itemStyles = [
        {
          normal: {
            show: true,
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#ff8d83",
              },
              {
                offset: 0.4,
                color: "#ff1804",
              },
              {
                offset: 0.8,
                color: "#ff3524",
              },
              {
                offset: 1,
                color: "#ff7064",
              },
            ]),
            barBorderRadius: 50,
            borderWidth: 0,
          },
        },
        {
          normal: {
            show: true,
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#f8d493",
              },
              {
                offset: 0.4,
                color: "#f1a724",
              },
              {
                offset: 0.8,
                color: "#f3b340",
              },
              {
                offset: 1,
                color: "#f6c978",
              },
            ]),
            barBorderRadius: 50,
            borderWidth: 0,
          },
        },
        {
          normal: {
            show: true,
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#83e0ff",
              },
              {
                offset: 0.4,
                color: "#04c0ff",
              },
              {
                offset: 0.8,
                color: "#24c8ff",
              },
              {
                offset: 1,
                color: "#64d8ff",
              },
            ]),
            barBorderRadius: 50,
            borderWidth: 0,
          },
        },
      ];
      var bgData = [];
      for (var i = 0; i < data.data.length; i++) {
        bgData.push(data.max);
        data.data[i].show = data.data[i].value;
        if (data.data[i].value < 0) {
          data.data[i].value = 0;
        }
        if (itemStyles[i]) {
          data.data[i].itemStyle = itemStyles[i];
        }
      }
      var option = {
        title: {
          text: data.title,
          left: "center",
          textStyle: {
            color: "#fff",
            fontWeight: "normal",
            fontSize: "16",
          },
        },
        grid: {
          borderWidth: 0,
          top: 0,
          left: 70,
          right: 40,
          bottom: 0,
          textStyle: {
            color: "#fff",
          },
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#363e83",
              },
            },
            axisLabel: {
              show: true,
              color: "#ffffff",
              interval: 0,
              formatter: function (value, i) {
                switch (i) {
                  case 0:
                    return "{a|" + value + "}";
                  case 1:
                    return "{b|" + value + "}";
                  case 2:
                    return "{c|" + value + "}";
                  default:
                    return value;
                }
              },
              rich: {
                a: {
                  fontSize: 14,
                  color: "#ff1400",
                },
                b: {
                  fontSize: 14,
                  color: "#f1a928",
                },
                c: {
                  fontSize: 14,
                  color: "#00bfff",
                },
              },
            },
            data: data.axis,
          },
          {
            type: "category",
            inverse: true,
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            data: data.axis,
          },
        ],
        xAxis: {
          type: "value",
          show: false,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#2f3640",
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#2f3640 ",
            },
          },
        },
        series: [
          {
            name: "",
            type: "bar",
            itemStyle: {
              normal: {
                show: true,
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#407b9d",
                  },
                  {
                    offset: 0.4,
                    color: "#06325d",
                  },
                  {
                    offset: 0.8,
                    color: "#06315c",
                  },
                  {
                    offset: 1,
                    color: "#0e507a",
                  },
                ]),
                barBorderRadius: 50,
                borderWidth: 0,
              },
            },
            label: {
              show: true,
              position: "right",
              color: "#8cd9ff",
              fontSize: 14,
              formatter: function (params) {
                switch (params.dataIndex) {
                  case 0:
                    return "{a|" + params.data.show + "%}";
                  case 1:
                    return "{b|" + params.data.show + "%}";
                  case 2:
                    return "{c|" + params.data.show + "%}";
                  default:
                    return params.data.show + "%";
                }
              },
              rich: {
                a: {
                  fontSize: 14,
                  color: "#ff1400",
                },
                b: {
                  fontSize: 14,
                  color: "#f1a928",
                },
                c: {
                  fontSize: 14,
                  color: "#00bfff",
                },
              },
            },
            zlevel: 2,
            barWidth: "20%",
            data: data.data,
          },
          {
            name: "",
            type: "bar",
            yAxisIndex: 1,
            zlevel: 1,
            itemStyle: {
              normal: {
                color: "#040f22",
                borderWidth: 0,
                barBorderRadius: 50,
                shadowBlur: {
                  shadowColor: "rgba(255,255,255,0.31)",
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowOffsetY: 2,
                },
              },
            },
            barWidth: "20%",
            data: bgData,
          },
        ],
      };
      chart.setOption(option);
    },
    // 全市工业经济发展情况 左下图表结束

    getProgyzjzByArea(month) {
      var _this = this;
      _this.$axios
        .get("/business/monitor/area/selectDistrictAddGrowth", {
          params: {
            dateRange: month,
          },
        })
        .then((result) => {
          var resultData = result.data.data;
          var zzArr = [];
          var areaArr = [];
          _this.$axios
            .get(`/system/config/selectRegionAndVersion`)
            .then((result) => {
              if (result.data.data.region && result.data.data.version) {
                _this.$axios
                  .get(
                    `/system/config/selectConfigByRegionAndKeyAndVersion?region=${result.data.data.region}&key=json.url&version=${result.data.data.version}`
                  )
                  .then((result) => {
                    var url = `${result.data.data.value}${_this.seatList[0].parentCode}.json`;
                    _this.$http.get(url).then((result) => {
                      var arr = result.body.features;

                      for (var i = 0; i < arr.length; i++) {
                        for (var j = 0; j < resultData.length; j++) {
                          if (arr[i].properties.adcode == resultData[j].code) {
                            areaArr.push({
                              name: resultData[j].name,
                              value: resultData[j].growth,
                              rank: resultData[j].rank,
                            });
                          }
                        }
                      }
                      var data = {
                        map: `/${_this.seatList[0].parentCode}.json`,
                        data: [
                          {
                            name: "增加值增速",
                            value: areaArr,
                          },
                        ],
                      };
                      _this.drawMap("map", data);
                    });
                  });
              } else {
                return;
              }
            });
        });
    },

    getProgyzjzByArea1(month) {
      var _this = this;
      _this.$axios
        .get("/business/monitor/area/selectDistrictInvestGrowth", {
          params: {
            dateRange: month,
          },
        })
        .then((result) => {
          var resultData = result.data.data;
          var zzArr = [];
          var areaArr = [];
          _this.$axios
            .get(`/system/config/selectRegionAndVersion`)
            .then((result) => {
              if (result.data.data.region && result.data.data.version) {
                _this.$axios
                  .get(
                    `/system/config/selectConfigByRegionAndKeyAndVersion?region=${result.data.data.region}&key=json.url&version=${result.data.data.version}`
                  )
                  .then((result) => {
                    var url = `${result.data.data.value}${_this.seatList[0].parentCode}.json`;
                    _this.$http.get(url).then((result) => {
                      var arr = result.data.features;
                      for (var i = 0; i < arr.length; i++) {
                        for (var j = 0; j < resultData.length; j++) {
                          if (arr[i].properties.name == resultData[j].name) {
                            areaArr.push({
                              name: resultData[j].name,
                              value: resultData[j].growth,
                              rank: resultData[j].rank,
                            });
                          }
                        }
                      }
                      var data = {
                        map: `/${_this.seatList[0].parentCode}.json`,
                        data: [
                          {
                            name: "增加值增速",
                            value: areaArr,
                          },
                        ],
                      };
                      _this.drawMap("map", data);
                    });
                  });
              } else {
                return;
              }
            });
        });
    },

    //地图绘制修改 开始
    drawMap(id, Data) {
      var that = this;
      let myCharts = this.$echarts.init(document.getElementById(id));
      var datas = Data.data;
      var coord = {},
        series = [],
        codes = {};
      that.$axios
        .get(`/system/config/selectRegionAndVersion`)
        .then((result) => {
          if (result.data.data.region && result.data.data.version) {
            that.$axios
              .get(
                `/system/config/selectConfigByRegionAndKeyAndVersion?region=${result.data.data.region}&key=json.url&version=${result.data.data.version}`
              )
              .then((result) => {
                var url = `${result.data.data.value}${that.seatList[0].parentCode}.json`;

                that.$http.get(url).then((result) => {
                  that.$echarts.registerMap("mapJson", result.body, {});
                  var features = result.body.features,
                    t = features.length;
                  for (var i = 0; i < t; i++) {
                    coord[features[i].properties["name"]] =
                      features[i].properties.center;
                    codes[features[i].properties["name"]] =
                      features[i].properties.adcode;
                  }

                  for (var a = 0, b = datas.length; a < b; a++) {
                    var convertData = datas[a].value;
                    for (var c = 0, d = convertData.length; c < d; c++) {
                      convertData[c].value = coord[convertData[c].name].concat(
                        convertData[c].value
                      );
                    }
                    /*地图上热点设置*/
                    series.push(
                      {
                        name: datas[a].name,
                        type: "effectScatter",
                        coordinateSystem: "geo",
                        roam: true,
                        symbolSize: function (val) {
                          var v = val[2];
                          if (v < -5) {
                            return 5;
                          } else if (v <= 0) {
                            return 10;
                          } else if (v <= 5) {
                            return 15;
                          } else if (v <= 10) {
                            return 20;
                          } else {
                            return 25;
                          }
                        },
                        data: convertData,
                        showEffectOn: "render",
                        rippleEffect: {
                          scale: 10,
                          period: 2,
                          brushType: "stroke",
                        },
                        hoverAnimation: false,
                        label: {
                          normal: {
                            color: "#fff",
                            formatter: "{b}",
                            position: "top",
                            fontSize: 17,
                            show: true,
                          },
                          emphasis: {
                            show: false,
                            fontSize: 17,
                            color: "#fff",
                          },
                        },
                        itemStyle: {
                          normal: {
                            label: {
                              show: true, //默认是否显示省份名称
                            },
                            areaColor: "rgba(0,0,0,0)",
                            borderWidth: 1.5,
                            borderColor: "#317ff8",
                            color: {
                              type: "linear",
                              x: 0,
                              y: 0,
                              x2: 0,
                              y2: 1,
                              colorStops: [
                                {
                                  offset: 0,
                                  color: "#bf7cf7", // 0% 处的颜色
                                },
                                {
                                  offset: 1,
                                  color: "#729df8", // 100% 处的颜色
                                },
                              ],
                              globalCoord: false, // 缺省为 false
                            },
                            shadowBlur: 10,
                            shadowColor: "#333",
                          },
                        },
                        zlevel: 1,
                      },
                      {
                        // 地图配置
                        name: "",
                        type: "map",
                        itemStyle: {
                          normal: {
                            label: {
                              show: false,
                            },
                            areaColor: "rgba(0,0,0,0)",
                            borderWidth: 1.5,
                            borderColor: "#317ff8",
                          },
                          emphasis: {
                            label: {
                              show: false,
                            },
                            areaColor: "#90c31d",
                          },
                        },
                        data: datas,
                      }
                    );
                  }

                  let option = {
                    // echarts 配置

                    tooltip: {
                      show: true,
                      trigger: "item",
                      formatter: function (params) {
                        var res = "";
                        if (params.seriesName == "工业投资增速") {
                          res += '<div class="big ec-tooltip">';
                        } else {
                          res += '<div class="ec-tooltip">';
                        }
                        res +=
                          '<div class="tooltipbg1"></div><div class="tooltipbg2"></div><div class="tooltipbg3"></div><ul>';
                        res +=
                          '<li class="f-color-59c8ff f-size-16">' +
                          params.name +
                          "</li>";
                        res += '<li class="f-p-t-xs f-size-18-i">增速';
                        if (params.data.value[2] < 0) {
                          res += '<i class="iconfont f-down">&#xeef5;</i>';
                        } else {
                          res += '<i class="iconfont f-up">&#xe667;</i>';
                        }
                        if (params.data.value[2]) {
                          res +=
                            '<span class="f-size-30">' +
                            Math.abs(params.data.value[2]) +
                            "</span>%</li>";
                        } else {
                          res += '<span class="f-size-30">-</span>%</li>';
                        }
                        if (params.data.rank) {
                          res +=
                            '<li class="f-color-59c8ff f-size-14">增速全市排名第<span class="f-size-20 f-color-white">' +
                            params.data.rank +
                            "</span>位</li>";
                        } else {
                          res +=
                            '<li class="f-color-59c8ff f-size-14">增速全市排名第<span class="f-size-20 f-color-white">-</span>位</li>';
                        }
                        if (params.data.proportion) {
                          res +=
                            '<li><span class="f-color-59c8ff f-size-14">工业投资额累计占比</span><span class="f-size-20 f-color-white">' +
                            params.data.proportion +
                            "</span>%</li>";
                        }
                        res += "</ul></div>";
                        return res;
                      },
                      backgroundColor: "rgba(0,0,0,0)",
                      position: function (point, params, dom, rect, size) {
                        return {
                          right: 40,
                          top: 0,
                        };
                      },
                    },
                    geo: {
                      // 地图配置
                      show: true,
                      map: "mapJson",
                      label: {
                        normal: {
                          show: false,
                        },
                        emphasis: {
                          show: false,
                        },
                      },
                      roam: true,
                      itemStyle: {
                        normal: {
                          areaColor: "rgba(0,0,0,0)",
                          borderColor: "#317ff8",
                          borderWidth: 2,
                        },
                        emphasis: {
                          areaColor: "#90c31d",
                        },
                      },
                      zoom: this.zoom,
                    },
                    series: series,
                  };

                  myCharts.setOption(option);
                });
              });
          } else {
            return;
          }
        });

      myCharts.on("click", function (params) {
        var code = codes[params.name];
        that.$router.push({
          path: "/areaSon",
          query: {
            name: params.name,
            code: code,
            month: this.dateValue,
          },
        });
      });
      this.autoShow(datas[0].value, myCharts);
    },
    //地图绘制修改 结束

    //自动轮播数据展示  开始
    autoShow(data, obj) {
      var dom = obj.getDom();
      var pw = dom.clientWidth || dom.offsetWidth;
      var i = 0,
        fw;
      if (fw) {
        clearInterval(fw);
      }
      fw = setInterval(function () {
        i == data.length ? (i = 0) : (i = i * 1);
        obj.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: i,
          position: function (point, params, dom, rect, size) {
            return {
              right: 40,
              top: 0,
            };
          },
        });
        i++;
      }, 2000);
      obj.on("mouseover", function (params) {
        dom.lastElementChild.className = "";
        clearInterval(fw);
      });
      obj.on("mouseout", function () {
        clearInterval(fw);
        fw = setInterval(function () {
          i == data.length ? (i = 0) : (i = i * 1);
          obj.dispatchAction({
            type: "showTip",
            seriesIndex: 0,
            dataIndex: i,
            position: function (point, params, dom, rect, size) {
              return {
                right: 40,
                top: 0,
              };
            },
          });
          i++;
        }, 2000);
      });
    },
    //自动轮播数据展示  结束
  },
};
</script>

<style scoped="scoped">
.content {
  top: 80px;
  padding: 15px 20px;
}

.layui-panel {
  background: url(../../../assets/img/bg001.png) center no-repeat;
  background-size: 100% 100%;
}

.layui-cards-title {
  background: url(../../../assets/img/jiantou.png) no-repeat;
}

.bg002 {
  background: url(../../../assets/img/bg002.png) center no-repeat;
  background-size: 100% 100%;
}

.f-right {
  height: 66px;
}

.aaaa {
  height: 66px;
}

#map {
  z-index: 3;
}
</style>